/**
 * The photograph beside the homepage headline.
 *
 * The hero was built as a text panel on a solid green background with no image
 * element in it, so there was nowhere for a picture to go. This is that slot.
 *
 * Set it to null and the hero renders exactly as it did before this slot
 * existed — an empty slot draws nothing rather than a missing picture.
 *
 * The description is not decoration: it is what a screen reader and a search
 * engine read instead of the photograph. It lives here, next to the address, so
 * that changing the picture changes the words with it rather than leaving the
 * previous photograph's description behind. Write it from what is in the frame,
 * not from the filename.
 *
 * What the frame wants: landscape, 2000 x 1500 or larger. It is shown as the
 * right-hand half of the hero and cropped to fill, so the rendered shape moves
 * between roughly 4:5 and 5:4 depending on the screen. Anything that has to
 * survive belongs in the middle: the left edge is faded into the green behind
 * the headline, and the top and bottom edges are the first to be cropped.
 */
export type HeroPicture = { url: string; alt: string };

export const HOME_HERO_PICTURE: HeroPicture | null = {
  url: '/assets/images/ftd-hero-machinery.jpg',
  alt: 'A forage harvester blowing silage into a trailer in a mown field under a summer sky',
};
